import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-canvas py-16 md:py-24" data-id="element-77" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-78" data-mp="1o3dim06d3rlc">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-grass-500 text-white" data-id="element-79" data-mp="2223g3gx3fta8">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-80" data-mp="1x54p378q82g9" />
        </span>

        <h2 className="mt-7 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-night md:text-5xl" data-id="element-81" data-mp="19faeyxfskrzp">
          Garantía 100% satisfacción o tu dinero de vuelta
        </h2>

        <div className="mt-9 rounded-2xl bg-white px-6 py-9 shadow-soft ring-1 ring-gray-200 md:px-10" data-id="element-82" data-mp="1j5c31p85aaem">
          <p className="text-lg leading-relaxed text-gray-600 md:text-xl" data-id="element-83" data-mp="1ec98bdrmsuwu">
            Si en los próximos 7 días no te parece que el Protocolo es exactamente lo que
            necesitabas para tu campaña de Septiembre Amarillo, te devolvemos cada peso. Sin
            preguntas, sin letra chica, sin condiciones. Sabemos que funciona porque lo vimos en
            cientos de profesionales.{' '}
            <span className="font-display font-extrabold text-night" data-id="element-84" data-mp="tx1msh1eg20b">Tu riesgo es CERO.</span>
          </p>
          <p className="mt-6 font-display text-lg font-extrabold leading-snug tracking-tight text-night md:text-xl" data-id="element-85" data-mp="yq4juz5dxtl9">
            Simplemente respondé a nuestro email diciendo que no es para vos, y procesamos el
            reembolso en 48 horas.
          </p>
        </div>
      </div>
    </section>;
}